const initValidateLivingAreaAndOrBuildingVolume = () => {
  var $LivingAreaAndOrBuildingVolumeInputGroup = $(
    "#living-area-and-or-building-volume-input-group"
  );
  var $livingAreaInput = $("#living-area");
  var $buildingVolumeInput = $("#building-volume");

  // Round and validate on change
  $livingAreaInput.on("change", function () {
    $(this).roundToStep();
    $LivingAreaAndOrBuildingVolumeInputGroup.trigger("validate");
  });
  $buildingVolumeInput.on("change", function () {
    $(this).roundToStep();
    $LivingAreaAndOrBuildingVolumeInputGroup.trigger("validate");
  });

  // Custom validation event
  $LivingAreaAndOrBuildingVolumeInputGroup.on("validate", function () {
    if (
      $livingAreaInput.getValidity() === true ||
      $buildingVolumeInput.getValidity(false) === true
    ) {
      $(this).setValidityClass(true);

      // Unset any invalid value
      if ($livingAreaInput.getValidity() === false) {
        $livingAreaInput.val("");
      }
      if ($buildingVolumeInput.getValidity() === false) {
        $buildingVolumeInput.val("");
      }
    } else {
      $(this).setValidityClass(false);
    }
  });
};

export { initValidateLivingAreaAndOrBuildingVolume };
